import { GenericEditField, DisplayScope, EditFieldKind } from "../DTO/GenericDTO";

export const EventSpecificEditFieldsTopLeft: GenericEditField[] = [
  {
    title: 'Veranstaltungsnummer',
    key1: 'data',
    key2: 'uniqueEventId',
    scope: DisplayScope.seminar,
    kind: EditFieldKind.uniqueEventId,
  },
  {
    title: 'Art der Veranstaltung',
    key1: 'tag',
    key2: 'eventKind',
    scope: DisplayScope.templateAndSeminarRead,
    kind: EditFieldKind.tag,
    className: 'w3-col s12 m3 l3',
  },
  {
    title: 'Fertigstellungspriorität',
    key1: 'tag',
    key2: 'priorityA',
    scope: DisplayScope.templateAndSeminar,
    kind: EditFieldKind.tag,
    className: 'w3-col s12 m3 l3',
  },
  {
    title: 'Auftragsstatus',
    key1: 'tag',
    key2: 'contractState',
    scope: DisplayScope.templateAndSeminar,
    // kind: EditFieldKind.tag,
    kind: EditFieldKind.multitag,
    oneForEachAppointment: 'plusMain',
    className: 'w3-col s12 m3 l3',
  },
  {
    title: 'Abrechnungsstatus',
    key1: 'tag',
    key2: 'billingStatus',
    scope: DisplayScope.templateAndSeminar,
    // kind: EditFieldKind.tag,
    kind: EditFieldKind.multitag,
    oneForEachAppointment: 'plusMain',
    className: 'w3-col s12 m3 l3',
  },
  {
    title: 'Einzeln Buchbar',
    key1: 'data',
    key2: 'individualBookable',
    scope: DisplayScope.templateAndSeminar,
    kind: EditFieldKind.check,
    // kind: EditFieldKind.multitag,
    className: 'w3-col s12 m12 l12',
  },
];

export const EventSpecificEditFieldsTopRight: GenericEditField[] = [
  
  {
    title: 'Bemerkungen',
    key1: 'data',
    key2: 'notes',
    className: 'w3-col s12 m12 l12 w3-round',
    emojiWhenFilled: '⚠️',
    scope: DisplayScope.templateAndSeminar,
    kind: EditFieldKind.textArea,
  },
  
]
export const EventSpecificEditFieldsStatus: GenericEditField[] = [
  {
    title: 'Fertigstellungsdatum',
    key1: 'data',
    key2: 'dueDate',
    scope: DisplayScope.templateAndSeminar,
    kind: EditFieldKind.date,
    className: 'w3-col s12 m6 l4',
  },
]
export const EventSpecificEditFieldsSubjects: GenericEditField[] = [
  {
    title: 'Bearbeitungsstand',
    key1: 'tag',
    key2: 'workStateTag',
    scope: DisplayScope.template,
    kind: EditFieldKind.tag,
    className: 'w3-col s12 m6 l4', 
  },
]

export const EventSpecificEditInvoices: GenericEditField[] = [
  {
    title: 'Abrechnungsstatus',
    key1: 'tag',
    key2: 'billingStatus',
    scope: DisplayScope.seminar,
    kind: EditFieldKind.tag,
  },
  {
    title: 'Angebotsnummer',
    key1: 'data',
    key2: 'offerId',
    scope: DisplayScope.seminar,
    kind: EditFieldKind.string,
  },
  {
    title: 'Umsatz',
    key1: 'data',
    key2: 'estimatedTurnover',
    scope: DisplayScope.seminar,
    kind: EditFieldKind.number,
  },
  {
    title: 'Umsatz offen',
    key1: 'data',
    key2: 'turnoverMising',
    scope: DisplayScope.seminar,
    kind: EditFieldKind.number,
  },
];
